'use strict'
module.exports = require('bindings')('secp256k1')



//////////////////
// WEBPACK FOOTER
// ./~/secp256k1/bindings.js
// module id = 1739
// module chunks = 0 1 2